document.addEventListener('DOMContentLoaded', () => {
    const triggers = document.querySelectorAll('.js--offcanvas-trigger');
    const closeButtons = document.querySelectorAll('.js--offcanvas-close');
    const overlay = document.querySelector('.js-offcanvas-overlay');
    const fixedDiv = document.getElementById('fixed_header_height');
    const body = document.body;

    triggers.forEach(trigger => {
        trigger.addEventListener('click', () => {
            const offcanvasId = trigger.getAttribute('data-offcanvas-trigger');
            const offcanvas = document.getElementById(offcanvasId);

            if (offcanvas) {
                openOffcanvas(offcanvas, trigger);
            }
        });
    });

    closeButtons.forEach(button => {
        button.addEventListener('click', () => {
            const offcanvas = button.closest('.js-offcanvas');
            if (offcanvas) {
                closeOffcanvas(offcanvas);
            }
        });
    });

    if (overlay) {
        overlay.addEventListener('click', () => {
            const openOffcanvas = document.querySelector('.js-offcanvas.open');
            if (openOffcanvas) {
                closeOffcanvas(openOffcanvas);
            }
        });
    }

    function openOffcanvas(offcanvas, trigger) {
        offcanvas.classList.add('open');
        body.classList.add('overflow-hidden');
        if(fixedDiv){
            fixedDiv.classList.add('z-[9999]');
        }

        if (overlay) {
            overlay.classList.add('active');
            console.log('Overlay attivato'); // <-- debug utile
        }

        offcanvas.dataset.triggerElement = trigger;
        offcanvas.setAttribute('aria-hidden', 'false');
        offcanvas.focus();

        document.addEventListener('keydown', trapFocus);
        document.addEventListener('keydown', escToClose);
    }


    function closeOffcanvas(offcanvas) {
        offcanvas.classList.remove('open');
        body.classList.remove('overflow-hidden');

        if(fixedDiv){
            fixedDiv.classList.remove('z-[9999]');
        }

        if (overlay) overlay.classList.remove('active');

        offcanvas.setAttribute('aria-hidden', 'true');

        const trigger = offcanvas.dataset.triggerElement;
        if (trigger && typeof trigger.focus === 'function') {
            trigger.focus();
        }

        document.removeEventListener('keydown', trapFocus);
        document.removeEventListener('keydown', escToClose);
    }

    function escToClose(e) {
        if (e.key === 'Escape') {
            const openOffcanvas = document.querySelector('.js-offcanvas.open');
            if (openOffcanvas) {
                closeOffcanvas(openOffcanvas);
            }
        }
    }

    function trapFocus(e) {
        const openOffcanvas = document.querySelector('.js-offcanvas.open');
        if (!openOffcanvas) return;

        const focusableSelectors = 'a, button, textarea, input, select, [tabindex]:not([tabindex="-1"])';
        const focusableElements = openOffcanvas.querySelectorAll(focusableSelectors);

        if (focusableElements.length === 0) return;

        const first = focusableElements[0];
        const last = focusableElements[focusableElements.length - 1];

        if (e.key === 'Tab') {
            if (e.shiftKey && document.activeElement === first) {
                e.preventDefault();
                last.focus();
            } else if (!e.shiftKey && document.activeElement === last) {
                e.preventDefault();
                first.focus();
            }
        }
    }
});
